
import React from "react";
import { certifications } from "../data/data";

export default function Certifications() {
    return (
        <section id="certifications" className="text-gray-400 bg-gray-900 body-font">
            <div className="container px-5 py-10 mx-auto">
                <div className="text-center mb-20">
                    <i class="fa-solid fa-pager fa-fade" style={{ color: "#63E6BE", fontSize: "50px" }}></i>
                    <h1 className="sm:text-4xl text-3xl font-medium title-font text-white mb-4">
                        Certifications
                    </h1>
                    <p className="text-base leading-relaxed xl:w-2/4 lg:w-3/4 mx-auto">
                        These are a list of certifications I have recieved. Click to view.
                    </p>
                </div>
                <div className="grid lg:w-4/5 sm:mx-auto sm:mb-2 -mx-2 justify-center">
                    {certifications.map((certificate) => (
                        <div key={certificate.title} className="p-2 mx-3 flex justify-center ">
                            <a href={certificate.link} target="_blank" rel="noreferrer">

                                <div className="bg-cyan-950 hover:bg-cyan-800 hover:scale-105 transition-all rounded-full justify-center flex px-4 py-2 min-w-[50vw] items-center ">
                                    <span className="title-font font-medium text-white text-center">
                                        {certificate.title}
                                    </span>
                                </div>
                            </a>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}